<template>
  <div class="four-grids">
    <div class="header" style="margin-top: .04rem;">
      <div>{{floorData.floorTitle}}</div>
      <a v-if="floorData.isMore === '0'" class="more" :href="!$isIframe ? floorData.moreUrl: 'javascript:void(0);'">
        <span>更多</span>
        <img src="@/assets/img/arrow-right.png" />
      </a>
    </div>
    <div class="content">
      <template v-if="floorData.data.length > 0">
        <div v-for="(item, idx) in floorData.data" :key="idx" class="box-item">
          <a @click='$jumpToPage(item)' >
            <img class="item-img" :src="item.imageUrl" />
          </a>
        </div>
    </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FourGrids',
  props: ['floorData']
}
</script>

<style lang="scss" scoped>
  .four-grids{
    padding: 0 .1rem;
    .content{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: -0.08rem;
      .box-item{
        margin-top: 0.08rem;
        width: 1.74rem;
        height: 1.13rem;
        border-radius: 5px;
        a{
          img{
            width: 100%;
            height: 100%;
            border-radius: 5px;
          }
        }
      }
    }
  }
</style>
